import * as React from 'react';
import Link from 'components/Link';
import Text from 'components/Text';
import Button from 'components/Button';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Row from 'components/Row';
import Image from 'components/Image';
import Label from 'components/Label';
import Select from 'components/Select';
import Columns2 from 'components/Columns2';
import Container from 'components/Container';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import LinkConstants from 'constants/LinkConstants';
import EventTracking from 'lib/EventTracking';

import './styles/AdminEngagementReport.scss';

type Props = {
  orgUuid: string;
  weeks: string[];
  selected: string;
  submitDisabled: boolean;
  eventPrefix: string;
  selectWeek: (week: string) => void;
  downloadEngagementReport: () => void;
};

export default function AdminEngagementReport(props: Props) {
  const options = props.weeks.map(week => ({
    label: `Week of ${week}`,
    value: week,
  }));

  const helpLink = {
    label: "Why don't I see more reports?",
    onClick: () => {
      EventTracking.trackKey(`${props.eventPrefix}.learn_more.click`);

      window.open(LinkConstants.ENGAGEMENT_REPORTS);
    },
  };

  return (
    <Container full flush className="AdminEngagementReport">
      <Box color="polar-bear" textAlign="left" noShadow noBorder>
        <MediaObject gutter="medium" figure="right">
          <BoxBody>
            <Heading level="3">New! Engagement Report</Heading>
            <Row>
              <Text element="p" size="large" color="pitch" lineHeight="large" weight="light" flush>
                Assess individual engagement on Remind across your organization with weekly
                engagement reports.
              </Text>
            </Row>
            <Row>
              <Label>Select a week</Label>
              <Columns2 gutter="xsmall">
                <Select
                  className={'AdminEngagementReport-select weeks--' + props.weeks.length}
                  options={options}
                  value={props.selected}
                  onChange={props.selectWeek}
                  appendedLinkItem={helpLink}
                />
                <Button
                  eventKey={`${props.eventPrefix}.button.click`}
                  weight="normal"
                  disabled={props.submitDisabled}
                  loading={props.submitDisabled}
                  onClick={props.downloadEngagementReport}>
                  Download report
                </Button>
              </Columns2>
            </Row>
            <Text element="p" size="medium" color="thunder" flush>
              Make the most of your report with{' '}
              <Link
                eventKey={`${props.eventPrefix}.learn_more.click`}
                href={LinkConstants.ENGAGEMENT_REPORTS}
                weight="semibold"
                target="_blank">
                this helpful guide
              </Link>
              .
            </Text>
          </BoxBody>
          <Image src={require('assets/images/engagement-reports.svg')} />
        </MediaObject>
      </Box>
    </Container>
  );
}
